export default __webpack_public_path__ + "media/images/fonts/glyphicons-halflings-regular-89889688147bd7575d6327160d64e760.svg";